angular.module('app.services').factory('socket', [
  '$rootScope',
  function socketFunction($rootScope) {
    let io = require('../../../node_modules/socket.io-client/dist/socket.io.js')
    var socket = io.connect(`${process.env.LEXSTEP_URL}/client-update`, {
      transports: ['websocket'],
    })
    return {
      on: function(eventName, callback) {
        socket.on(eventName, function() {
          var args = arguments
          $rootScope.$apply(function() {
            callback.apply(socket, args)
          })
        })
      },
      emit: function(eventName, data, callback) {
        socket.emit(eventName, data, function() {
          var args = arguments
          $rootScope.$apply(function() {
            if (callback) {
              callback.apply(socket, args)
            }
          })
        })
      },
    }
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/services/socket.js